import api from '@/lib/api';
import type {
  AdminUserListResponse,
  AdminUserDetail,
  NotifyPayload,
  ImpersonateResponse,
} from '@/types/admin';

export interface UsersQuery {
  q?: string;
  plan?: string;
  status?: string;
  lastLoginBefore?: string;
  lastLoginAfter?: string;
  signupAfter?: string;
  hasIntent?: boolean;
  sort?: string;
  page?: number;
  perPage?: number;
}

export async function fetchUsers(params: UsersQuery): Promise<AdminUserListResponse> {
  const { data } = await api.get<{ data: AdminUserListResponse } | AdminUserListResponse>(
    '/admin/users',
    { params },
  );
  // Backend may return either {data: {...}} or the body directly
  const body = data as AdminUserListResponse & { data?: AdminUserListResponse };
  return body.data ?? body;
}

export async function fetchUser(id: string): Promise<AdminUserDetail> {
  const { data } = await api.get<{ data: AdminUserDetail } | AdminUserDetail>(`/admin/users/${id}`);
  const body = data as AdminUserDetail & { data?: AdminUserDetail };
  return body.data ?? body;
}

export async function notifyUser(id: string, payload: NotifyPayload): Promise<void> {
  await api.post(`/admin/users/${id}/notify`, payload);
}

export async function grantTrialExtension(id: string, days: number): Promise<void> {
  await api.post(`/admin/users/${id}/grant-trial-extension`, { days });
}

export async function impersonateUser(id: string): Promise<ImpersonateResponse> {
  const { data } = await api.post<{ data: ImpersonateResponse } | ImpersonateResponse>(
    `/admin/users/${id}/impersonate`,
  );
  const body = data as ImpersonateResponse & { data?: ImpersonateResponse };
  return body.data ?? body;
}
